var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.606 25.5H7.187a1.177 1.177 0 0 0 0 2.355h9.419a1.177 1.177 0 0 0 0-2.355zM9.542 20.426H7.187a1.177 1.177 0 0 0 0 2.355h2.355a1.177 1.177 0 1 0 0-2.355z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.001 34H3.867a3.732 3.732 0 0 1-3.732-3.732V7.123A3.732 3.732 0 0 1 3.867 3.39h12.739a1.177 1.177 0 0 1 0 2.354H3.867a1.377 1.377 0 0 0-1.389 1.378v23.133a1.39 1.39 0 0 0 1.378 1.378H27a1.389 1.389 0 0 0 1.377-1.378V17.518a1.177 1.177 0 0 1 2.355 0v12.738A3.73 3.73 0 0 1 27.001 34z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 14.127A7.064 7.064 0 1 1 26.802 0a7.064 7.064 0 0 1 0 14.128zm0-11.772a4.71 4.71 0 1 0 .001 9.418 4.71 4.71 0 0 0 0-9.418z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26.8 14.127A7.064 7.064 0 1 1 26.802 0a7.064 7.064 0 0 1 0 14.128z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTest);
export default __webpack_public_path__ + "static/media/cardTest.2ed7ba884c0f7fdadb71126181cab8de.svg";
export { ForwardRef as ReactComponent };